import { Badge } from '@/shared/ui/badge'
import { Label } from '@/shared/ui/label'
import { Switch } from '@/shared/ui/switch'
import { t } from '@/shared/lib/i18n'
import { cn } from '@/shared/lib/utils'

interface HideNonComplianceToggleProps {
  instrumentId: number
  hideNonCompliance: boolean
  ncOpenCount: number
  disabled?: boolean
  onHideNonComplianceChange: (hide: boolean) => void
}

const HideNonComplianceToggle = ({
  instrumentId,
  hideNonCompliance,
  ncOpenCount,
  disabled = false,
  onHideNonComplianceChange,
}: HideNonComplianceToggleProps) => {
  const toggleId = `nc-toggle-${instrumentId}`
  const ncOpenCountDescriptionId = `${toggleId}-open-count`

  return (
    <div className="flex items-center gap-2">
      <Switch
        id={toggleId}
        checked={hideNonCompliance}
        disabled={disabled}
        onCheckedChange={onHideNonComplianceChange}
        aria-describedby={ncOpenCountDescriptionId}
      />
      <Label
        htmlFor={toggleId}
        className={cn('text-xs text-muted-foreground', !disabled && 'cursor-pointer')}
      >
        {t('taskQueue.toggle.hideNonCompliance')}
      </Label>
      {ncOpenCount > 0 && (
        <Badge variant="secondary" className="text-xs px-1.5 py-0 h-4" aria-hidden="true">
          {ncOpenCount}
        </Badge>
      )}
      <span id={ncOpenCountDescriptionId} className="sr-only" aria-live="polite">
        {t('taskQueue.toggle.ncOpenCountDescription', { count: ncOpenCount })}
      </span>
    </div>
  )
}

export { HideNonComplianceToggle }
